<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      
    </template>
    <template slot="body">

      <div class="ut-flex">
        <TextField
          style="flex:1"
          class="m1"
          required
          :id="'searchString'"
          v-bind="textFieldConfig"
          :value="searchString"
          :placeholder="'Search'"
          @keyup="onSearchInputKeyup"
        
        >
        </TextField>
        <div style="flex:1;margin-left:20px">

        </div>
        
        
      </div>

            <div class="ut-fh ut-fc" style="max-height:300px;height:300px">
             <NTable
                id="catalog-releases-releases_list"
                class="h1"
                :config="tableConfig"
                :headers="Headers"
                :items="list"
                thpad="0px"
                tdpad="0px"
                thspad="0px 10px 0px 10px"
                tdbdr="1px solid var(--sprt-12)"
                
            >
                <template v-slot:item="{ item, tdcon }">
                <tr>
                  <td v-bind="tdcon('account_name')">
                    <span @click="onRowClick(item)" >{{item['account_name']}} </span>
                  </td>
                  <td v-bind="tdcon('short')">
                    <span>{{item['short_name']}}</span>
                  </td>

                  <td v-bind="tdcon('account_type')">
                      <span>{{item['account_type'] }}</span>
                  </td>
                  <td v-bind="tdcon('format')">
                    <span v-if="item['physical']" class="txtov">{{$t('physical')}}</span>
                    <span v-else class="txtov">{{$t('digital')}}</span>
                  </td> 
                    
                </tr>
                </template>
            </NTable>
         

       
            </div>
        
    </template>
    <template slot="options">
        <button class="dt-button s7" @click="onCancelClick" >Cancel</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';


import NTable from "../../../../plugins/datatable/datatable";








import ModalContainer from "@dtplugins/modal/modal-container";

import {  closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";


import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";



import {
  createTV,
  tv,
} from "../../../../models/text-value.model";


import { MHTTPCL } from '../../../../services/http/http-client';
import { SupplierOrdersService } from '../../services/supplier.order.service';

import { Subject } from "rxjs";
import { waitForAnimation, subscribeSubject } from "@/utility";

export default {
  components: {
    
    Modal,
    NTable,


    ModalContainer,   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const modalInitData = await SupplierOrdersService.searchAccounts(this.supplier_order_id);
    console.log(modalInitData,":::::::::::::::::")
    this.list =modalInitData.data.accounts;


        subscribeSubject(this, this.searchSubject$, searchString => {
        
        SupplierOrdersService.searchAccounts(this.supplier_order_id,searchString).then(res=>{
          console.log("SEARCH RES",res)
          this.list=res.data.accounts;
        });
        
       
      })
  },
  data: function () {
    return {

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      }),

      list:[],

    

      searchSubject$: new Subject(),

      searchString: "",

    };
  },
  mixins: [
    
  ],

  computed: {
    Headers: function () {
      return [
        createTableHeader("account_name", { }),
        createTableHeader("short", {  }),
        createTableHeader("account_type", {  }),
        createTableHeader("format", { text:'Digital/Physical'}),

      ];
    },

    supplier_order_id:function(){
      return this.$route.query.supplier_order_id;
    }
  
  
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value);
      this.searchSubject$.next(this.searchString);
    },

    onRowClick:function(item){
      console.log(item)
      const { account_name ,account_id } = item;



     this.$emit('change',
                    {   name:'account_name' , 
                        value:account_name ,
                        item_id:account_id , 
                        supplier_order_id:this.supplier_order_id ,
                        objKey:'so_account'
                    }
                )
    }
  
  },

  // [
  //   {"product_id":"76","order_qty":10,"cost_price":2.1,"foc_qty":10},
  //   {"product_id":"77","order_qty":20,"cost_price":2.1,"foc_qty":20}
  // ]
};
</script>